/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPopularArticlesExportAll } from 'state/thunks/articlesentimentv2';
// material
import TableReportSection from "material/tablereportsection/tablereportsection";
import { SingleSelectDropDown, Tip } from '@insticator/insticator-ui/dist/material';
// styles
import injectSheet from 'react-jss';
import styles from './toparticlesreport_styles';
import Space from 'material/space/space';

const articlesMetricOptions = [
    {name: 'All Reactions', value: 'total'},
    {name: 'Like', value: 'like'},
    {name: 'Dislike', value: 'dislike'},
    {name: 'Love', value: 'love'},
    {name: 'Funny', value: 'funny'},
    {name: 'Sad', value: 'sad'},
    {name: 'Angry', value: 'angry'},
    {name: 'Shocked', value: 'shocked'},
    {name: 'Thoughtful', value: 'thoughtful'}
]

const defaultColumns = [
    {
        key: 'rank',
        title: 'Rank'
    },
    {
        key: 'title',
        title: 'Title',
        url: 'pageUrl'
    },
    {
        key: 'count',
        title: 'All Reactions',
        format: 'comma'
    }
]


const articleMetricMap = (name) => {
    return articlesMetricOptions.filter(avatarPack => avatarPack.value === name)?.pop() || articlesMetricOptions[0]
}
/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT V2 ANALYTICS - TOP ARTICLES REPORT ~~~~~~~~~~ ========== */
const TopArticlesReport = injectSheet(styles)((props) => {
    const dispatch = useDispatch()
    const { data, status } = useSelector((state) => state.articleSentimentV2.popularArticlesReport);

    const { selectedMetric, selectMetric, requestData } = props

    const tableColumns = useMemo(() => {
        let columns = [...defaultColumns]
        columns[2].title = articlesMetricOptions.filter(opt => opt.value === selectedMetric)[0].name
        return columns
    }, [selectedMetric])

    const handleExportDataTransform = (obj) => obj.map(row => {
        const formattedRow = {};
        defaultColumns.forEach(columnConfig => {
            formattedRow[columnConfig.key] = row[columnConfig.key];
        })
        return formattedRow;
    });

    const exportDataConfig = {
        fileName: `top_article_by_reaction_${selectedMetric}`,
        excludedColumns: ['thoughtful count', 'dislike count', 'angry count', 'love count', 'like count', 'funny count', 'sad count', 'shocked count'],
        transpiler: handleExportDataTransform
    };
    const exportAllDataConfig = {
        onClick: () => {
            dispatch(fetchPopularArticlesExportAll(requestData));
        }
    }
    const includeTotalColumn = (data) => {
        return data.map(row => {
            return {
                ...row,
            }
        })
    };

    const tooltip = useMemo(() => {
        return {
            title: 'Reactions',
            content: 'Shows a list of the top articles on your site ranked by the number of emoji reactions each article has received.'
        }
    }, [])

    return (
        <div name={'toparticlesreport'} class={`${props.classes.toparticlesreport}`} >
            <Space direction={'column'} gap={20}>
                <Space justifyContent={'space-between'}>
                    <p>Top Articles by Reaction</p>
                    <Tip 
                        space={'left'} 
                        icon={'question-circle'} 
                        content={
                            <div className={'tip-content'}>
                                <div className={'tip-title'}>
                                    <h4>{tooltip.title}</h4>
                                </div>
                                <div className={'tip-desc'}>
                                    <p>{tooltip.content}</p>
                                </div>
                            </div>
                        }
                    />
                </Space>
                <SingleSelectDropDown 
                    name={articleMetricMap(selectedMetric).name} 
                    searchable={false} 
                    onSelect={(opt) => selectMetric(opt.value)} 
                    items={articlesMetricOptions}
                />
                <TableReportSection
                    columns={defaultColumns}
                    data={includeTotalColumn(data.slice(0, 20))}
                    rowsPerPage={5}
                    exportData={exportDataConfig}
                    exportAll={exportAllDataConfig}
                    loading={status === 'pending'}
                />
            </Space>
            
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TopArticlesReport;
